import { useEffect, useState } from 'react';
import { FormHelperText, InputLabel, OutlinedInput } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import { FormDrawer, FormDrawerGroup } from '../../../../components/form-drawer';
import { IQuestionAnswerCategoryAddEditRequest } from '../../../../model/apm/question-answer/request/question-answer-category-add-edit-request';
import { IQuestionAnswerCategoryResponse } from '../../../../model/apm/question-answer/response/question-answer-category-response';

interface QuestionAnswerCategoryDrawerProps {
    open: boolean;
    initial?: IQuestionAnswerCategoryResponse;
    isSaving: boolean;
    onClose: () => void;
    onSave: (value: IQuestionAnswerCategoryAddEditRequest) => void;
}

export function QuestionAnswerCategoryDrawer({ open, initial, isSaving, onClose, onSave }: QuestionAnswerCategoryDrawerProps) {
    const [description, setDescription] = useState('');
    const [showValidationErrors, setShowValidationErrors] = useState(false);
    const isEdit = !!initial;
    const descriptionError = showValidationErrors && !description.trim();

    useEffect(() => {
        if (!open) return;
        setDescription(initial?.description || '');
        setShowValidationErrors(false);
    }, [open, initial]);

    function handleSave() {
        if (!description.trim()) {
            setShowValidationErrors(true);
            return;
        }
        onSave({ description: description.trim() });
    }

    return (
        <FormDrawer
            open={open}
            icon={<CategoryIcon />}
            title={isEdit ? 'Editar categoria' : 'Nova categoria'}
            subtitle={isEdit ? initial?.description : 'Agrupa as perguntas frequentes do portal'}
            saveLabel={isEdit ? 'Salvar alterações' : 'Adicionar categoria'}
            isSaving={isSaving}
            onClose={onClose}
            onSave={handleSave}
        >
            <FormDrawerGroup title="Identificação" description="Nome exibido como agrupador na página de perguntas frequentes.">
                <InputLabel required>Descrição</InputLabel>
                <OutlinedInput
                    fullWidth
                    autoFocus
                    autoComplete="off"
                    inputProps={{ maxLength: 250 }}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleSave()}
                    error={descriptionError}
                />
                {descriptionError && <FormHelperText error>Descrição é obrigatória</FormHelperText>}
            </FormDrawerGroup>
        </FormDrawer>
    );
}
